var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.991 511.991",
    height: 512,
    viewBox: "0 0 511.991 511.991",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fa4a10",
    d: "m410.9 103.636c-35.604-3.486-91.379-7.641-154.909-7.641s-119.306 4.154-154.909 7.641c-27.766 2.718-49.885 23.881-53.791 51.465-4.844 34.204-7.3 68.149-7.3 100.895s2.456 66.69 7.3 100.894c3.906 27.585 26.025 48.748 53.791 51.466 35.604 3.486 91.379 7.641 154.909 7.641s119.306-4.154 154.909-7.641c27.766-2.718 49.885-23.881 53.791-51.465 1.549-10.937 11.671-18.549 22.606-16.999 10.938 1.549 18.547 11.67 16.999 22.606-6.503 45.918-43.306 81.146-89.5 85.668-36.489 3.572-93.661 7.83-158.806 7.83s-122.316-4.258-158.806-7.83c-46.194-4.521-82.997-39.75-89.5-85.668-10.247-72.729-10.247-140.275 0-213.005 6.503-45.917 43.306-81.146 89.5-85.667 36.489-3.572 93.661-7.83 158.806-7.83s122.316 4.258 158.806 7.83c46.194 4.521 82.997 39.75 89.5 85.668 5.105 36.055 7.694 71.887 7.694 106.502-1.045 26.51-38.942 26.541-40 0 0-32.745-2.456-66.69-7.3-100.893-3.905-27.586-26.024-48.749-53.79-51.467zm-77.401 120.228c25.852 14.436 25.846 53.332 0 67.763l-85.854 49.819c-12.215 7.087-26.814 7.113-39.05.064-12.275-7.069-19.604-19.759-19.604-33.945v-99.639c0-14.187 7.329-26.876 19.604-33.945 12.236-7.048 26.835-7.022 39.05.064zm-21.31 33.882-83.198-48.277v96.556z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3994d6f298263e10ac9a18965799c8d2.svg";
export { ForwardRef as ReactComponent };